import VContainer from './VContainer'
import VCol from './VCol'
import VRow from './VRow'
import VSpacer from './VSpacer'
import VLayout from './VLayout'
import VFlex from './VFlex'

export {
  VContainer,
  VCol,
  VRow,
  VSpacer,
  VLayout,
  VFlex,
}

export default {
  $_ifrontui_subcomponents: {
    VContainer,
    VCol,
    VRow,
    VSpacer,
    VLayout,
    VFlex,
  },
}
